<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('cargopublico')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Cargos Públicos del {{title}}
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>
          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('cargopublico')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            <span align="justify">
              ¿Usted ha ejercido un cargo público de dirección (PEP: persona expuesta políticamente) en los últimos 5 años? *
            </span>
          </md-card-header>
          <md-card-content>           
              <div>
                <md-checkbox v-model="form.cargopublico" :disabled="isDisabled" value="Si">Sí</md-checkbox>
                <md-checkbox v-model="form.cargopublico" :disabled="isDisabled" value="No">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('cargopublico')">
                <span class="md-error" v-if="!$v.form.cargopublico.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>          

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>  

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item7',
  props: ["title", "data", "isDisabled"],
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item7
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        cargopublico: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item7
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        var index = "0"
        if(this.data.name == "Participe"){
          if(this.form.cargopublico == "Si"){
            index = "8"
          }else{
            index = "9"
          }
        }
        else{
          if(this.form.cargopublico == "Si"){
            index = "8"
          }else{
            index = "10"
          }          
        }        
        
        this.$emit('setSaveForm', {id:"7", form: this.form, index: index});
        
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
